import type { MetadataRecord, ProgramRecord, SalaryBenchmarkRecord, TuitionRecord } from './types';

export interface DataBundle {
  programs: ProgramRecord[];
  tuition: TuitionRecord[];
  salaryBenchmarks: SalaryBenchmarkRecord[];
  metadata: MetadataRecord;
}

export async function loadDataBundle(): Promise<DataBundle> {
  const [programs, tuition, salaryBenchmarks, metadata] = await Promise.all([
    fetch('/data/programs.json').then((res) => res.json() as Promise<ProgramRecord[]>),
    fetch('/data/tuition.json').then((res) => res.json() as Promise<TuitionRecord[]>),
    fetch('/data/salary-benchmarks.json').then((res) => res.json() as Promise<SalaryBenchmarkRecord[]>),
    fetch('/data/metadata.json').then((res) => res.json() as Promise<MetadataRecord>)
  ]);

  return { programs, tuition, salaryBenchmarks, metadata };
}
